// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_CriaContaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /contas/cria_conta
 *
 * Returns the newly-created conta_id. Wire shape preserves the legacy
 * `{ conta_id: int }` object emit (not a primitive).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contas_CriaContaResponseDados {
conta_id: number
}

export type Contas_CriaContaResponse = ApiResponse<Contas_CriaContaResponseDados>;

registerResponseContract('Contas_CriaContaResponse', {
  conta_id: { type: 'number',  required: true },
})
